import { ClipboardList, MessageSquare, Users } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";

import { cn } from "@/lib/utils";

const triggerClass =
  "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all";

export function DashboardNav({
  unackedNotesTotal,
  canReviewFieldNotes,
}: {
  unackedNotesTotal: number;
  canReviewFieldNotes: boolean;
}) {
  const pathname = useLocation().pathname;
  const employeeActive = pathname.startsWith("/employee");
  const fieldNotesActive = pathname === "/field-notes" || pathname.startsWith("/field-notes/");
  const adminActive = pathname.startsWith("/admin");

  return (
    <div className={cn("inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground", "flex flex-wrap h-auto")}>
      <NavLink
        to="/employee/clock"
        end={false}
        data-testid="nav-employee"
        role="tab"
        aria-selected={employeeActive}
        className={cn(triggerClass, employeeActive ? "bg-background text-foreground shadow-sm" : "hover:text-foreground")}
      >
        <Users className="mr-2 size-4" />
        Employee
      </NavLink>
      <NavLink
        to="/field-notes"
        data-testid="nav-field-notes"
        role="tab"
        aria-selected={fieldNotesActive}
        className={cn(triggerClass, fieldNotesActive ? "bg-background text-foreground shadow-sm" : "hover:text-foreground")}
      >
        <MessageSquare className="mr-2 size-4" />
        Field Notes
      </NavLink>
      <NavLink
        to="/admin"
        data-testid="nav-admin"
        role="tab"
        aria-selected={adminActive}
        className={cn(triggerClass, adminActive ? "bg-background text-foreground shadow-sm" : "hover:text-foreground")}
      >
        <ClipboardList className="mr-2 size-4" />
        Admin
        {canReviewFieldNotes && unackedNotesTotal > 0 && (
          <span className="ml-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-destructive text-[10px] font-bold text-destructive-foreground">
            {unackedNotesTotal}
          </span>
        )}
      </NavLink>
    </div>
  );
}
